import { payment } from "./payment";

export const getMonthlyInstalment = (
	annualRatePercent: number,
	years: number,
	principal: number,
) =>
	Math.round(
		Math.abs(payment(annualRatePercent / 1200, years * 12, principal)),
	);
